import FrameConfig from "@lib/classes/FrameConfig";
import Session from "@utils/session";

export const event = (eventName: string, eventData?: Record<string, any>) => {
  const serviceArea = Session.getBooking()?.serviceArea || new FrameConfig().serviceArea;
  const serviceAreaName =
    Session.getBooking()?.serviceAreaName || new FrameConfig().serviceAreaName;
  eventData ||= {};

  if (!global.window) return;

  if (window.gtmEnabled)
    window.dataLayer.push({
      event: `BE:${eventName}`,
      ...eventData,
      ecommerce: { service_area: serviceArea, service_area_name: serviceAreaName },
    });
  if (window.ga4Enabled)
    window.gtag("event", `BE:${eventName}`, {
      ...eventData,
      service_area: serviceArea,
      service_area_name: serviceAreaName,
    });
};

export const beginCheckout = (booking: be.Booking) => {
  if (!booking) return;
  const parentUrl = new FrameConfig().parentUrl;

  const data = {
    value: booking.total(),
    bookingPage: parentUrl ? parentUrl.split("?")[0] : undefined,
    currency: global.window.currency,
    coupon: booking.profiles?.couponWeb,
    service_area: booking.serviceArea,
    service_area_name: booking.serviceAreaName || new FrameConfig().serviceAreaName,
    items: booking.activeLegs().map((leg: be.Reservation, i: number) => ({
      item_id: leg.resId,
      item_name: `${leg.pickup?.displayName} => ${leg.dropoff?.displayName}`,
      price: leg.service?.fareDisplay,
      index: i,
      coupon: booking.profiles?.couponWeb,
      item_category: leg.service?.name,
      quantity: 1,
    })),
  };

  if (window.gtmEnabled) window.dataLayer.push({ event: "begin_checkout", ecommerce: data });
  if (window.ga4Enabled) window.gtag("event", "begin_checkout", data);
};

export const selectItem = (leg: be.Reservation, service: be.Service) => {
  if (!leg || !service) return;
  const parentUrl = new FrameConfig().parentUrl;

  const data = {
    bookingPage: parentUrl ? parentUrl.split("?")[0] : undefined,
    service_area: Session.getBooking().serviceArea,
    service_area_name: Session.getBooking()?.serviceAreaName || new FrameConfig().serviceAreaName,
    item_list_name: `${leg.pickup?.displayName} => ${leg.dropoff?.displayName}`,
    items: [
      {
        item_id: service.serviceType,
        item_name: service.name,
        price: service.fareDisplay,
      },
    ],
  };

  if (window.gtmEnabled) window.dataLayer.push({ event: "select_item", ecommerce: data });
  if (window.ga4Enabled) window.gtag("event", "select_item", data);
};

export const viewItemList = (leg: be.Reservation, services: be.Service[]) => {
  if (!leg || !services) return;
  const parentUrl = new FrameConfig().parentUrl;

  const data = {
    bookingPage: parentUrl ? parentUrl.split("?")[0] : undefined,
    service_area: Session.getBooking().serviceArea,
    service_area_name: Session.getBooking()?.serviceAreaName || new FrameConfig().serviceAreaName,
    item_list_name: `${leg.pickup?.displayName} => ${leg.dropoff?.displayName}`,
    items: services.map((service: be.Service, i: number) => ({
      item_id: service.serviceType,
      item_name: service.name,
      price: service.fareDisplay,
      index: i,
    })),
  };

  if (window.gtmEnabled) window.dataLayer.push({ event: "view_item_list", ecommerce: data });
  if (window.ga4Enabled) window.gtag("event", "view_item_list", data);
};

export const purchase = (booking: be.Booking) => {
  if (!booking || booking.edit) return;
  const parentUrl = new FrameConfig().parentUrl;

  const data = {
    bookingPage: parentUrl ? parentUrl.split("?")[0] : undefined,
    transaction_id: booking.itineraryId,
    value: booking.total(),
    currency: global.window.currency,
    coupon: booking.profiles?.couponWeb,
    service_area: booking.serviceArea,
    service_area_name: booking.serviceAreaName || new FrameConfig().serviceAreaName,
    items: booking.activeLegs().map((leg: be.Reservation, i: number) => ({
      item_id: leg.resId,
      item_name: `${leg.pickup?.displayName} => ${leg.dropoff?.displayName}`,
      price: leg.service?.fareDisplay,
      index: i,
      coupon: booking.profiles?.couponWeb,
      item_category: leg.service?.name,
      quantity: 1,
    })),
  };

  if (window.gtmEnabled) window.dataLayer.push({ event: "purchase", ecommerce: data });
  if (window.ga4Enabled) window.gtag("event", "purchase", data);
};
